var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.dialogBox.message))]),_c('b-form-input',{model:{value:(_vm.dialogBox.answer),callback:function ($$v) {_vm.$set(_vm.dialogBox, "answer", $$v)},expression:"dialogBox.answer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }